import {
  LEGEND_WIDTH,
  LEGEND_PADDING,
  LEGEND_ROW_HEIGHT,
  LEGEND_HEADER_BOTTOM_GAP,
} from "./constants";
import type { ComputeLegendDimensions } from "./types";

export const computeLegendDimensions: ComputeLegendDimensions = ({
  itemCount,
  scale,
}) => ({
  width: LEGEND_WIDTH * scale,
  height:
    (LEGEND_PADDING * 2 +
      LEGEND_ROW_HEIGHT * (itemCount + 1) +
      LEGEND_HEADER_BOTTOM_GAP) *
    scale,
});
